export enum ToolpanelType {
  settings = 'SETTINGS',
  column = 'COLUMN',
  filter = 'FILTER',
  presets = 'PRESETS',
}
